import {
  React,
  userState,
  forwardRef,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import Box from "@mui/material/Box";
import scan from "../../assets/add.png";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Link, useHistory } from "react-router-dom";
import NavBar from "../Navbar/Navbar";
import notFound from "../../assets/notFound.png";
import CircularProgress from "@mui/material/CircularProgress";
import ReactPaginate from "react-paginate";
import Snackbar from "@mui/material/Snackbar";
import getCookie, { setAdminCookie } from "../../Atom";
import "./LaunchtrakFlight.css";
import Tooltip from "@mui/material/Tooltip";
import ScanDevice from "../ScanDevice/ScanDevice";
import { getLaunchTrekData } from "./api";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import EditFile from "./EditFile/EditFile";
import DeleteFiles from "../dialogs/DeleteFiles";
import subject from "../../../modules/mySubject";
import { ltk4, ltk5 } from "../../../ActualLtk";
const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "File Name",
    width: "100px"
  },
  {
    id: "originalName",
    numeric: false,
    disablePadding: true,
    label: "Original Name",
  },
  {
    id: "pressure",
    numeric: false,
    disablePadding: true,
    label: "Pressure",
  },
  {
    id: "volumeOfWater",
    numeric: false,
    disablePadding: true,
    label: "VOW",
  },
  {
    id: "volumeOfEngine",
    numeric: true,
    disablePadding: true,
    label: "VOE",
  },
  {
    id: "nozzleSize",
    numeric: true,
    disablePadding: true,
    label: "Nozzle Size ",
  },
  {
    id: "rocketDryMass",
    numeric: true,
    disablePadding: true,
    label: "RDM",
  },
  {
    id: "parachuteSize",
    numeric: true,
    disablePadding: true,
    label: "Parachute Size",
  },
  {
    id: "createdAt",
    numeric: true,
    disablePadding: true,
    label: "Uploaded on",
  },
];
function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            key={headCell?.id}
            align={"center"}
            padding={"normal"}
            sortDirection={orderBy === headCell?.id ? order : false}
            sx={{
              width: "100px",
              maxWidth: "150px",
            }}
          >
            <Tooltip
              title={
                headCell?.label === "VOW"
                  ? "Volume of Water"
                  : headCell?.label === "VOE"
                  ? "Volume of Engine"
                  : headCell?.label === "RDM"
                  ? "Rocket Dry Mass"
                  : headCell?.label
              }
              placement="top"
            >
              <TableSortLabel
                className="sort-header"
                sx={{
                  display: "flex",
                }}
                active={orderBy === headCell?.id}
                direction={orderBy === headCell?.id ? order : "asc"}
                onClick={createSortHandler(headCell?.id)}
              >
                {headCell?.label}
              </TableSortLabel>
            </Tooltip>
          </TableCell>
        ))}
        <TableCell
          align={"center"}
          padding={"normal"}
          sx={{ width: "50px", maxWidth: "80px" }}
        >
          <div className=" mb-2 ">View</div>
        </TableCell>
        <TableCell
          align={"center"}
          padding={"normal"}
          sx={{ width: "100px", maxWidth: "150px" }}
        >
          <div className=" mb-2">Action</div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const EnhancedTableToolbar = (props) => {
  // const { numSelected } = props;
  return <div className="pt-10"></div>;
};
EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
let readableStreamClosed;
let reader;
let port,
  textEncoder,
  writableStreamClosed,
  writer = -1;
let currentCommand = "";
let filenames = [];
let startedDumpingFile = false;
let graphData = [];
let dumpedData = "";
let localData = "";
let valuesOfInterest = [];
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function LaunchtrakFlight(props) {
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [pageLimit, setPageLimit] = useState(25);
  const [page, setPage] = useState(0);
  const [serial, setSerial] = useState(null);
  const [loading, setLoading] = useState(false);
  const [noOfPages, setNoOfPages] = useState(50);
  const [currPage, setCurrPage] = useState(0);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");
  const [snackBarShow, setSnackBarShow] = useState(false);
  const [paged, setPaged] = useState(0);
  const [loadings, setLoadings] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(pageLimit);
  const [selected, setSelected] = useState([]);
  const [myUser, setmyUser] = useState(userState);
  const [open, setOpen] = useState(false);
  const [dense, setDense] = useState(false);
  const history = useHistory();
  const [scanLoading, setScanLoading] = useState(false);
  let search = window.location.search;
  let params = new URLSearchParams(search);
  // STATE FOR DEVICE AND GET FILES
  const [fileNames, setFileNames] = useState([]);
  const [deviceInfo, setDeviceInfo] = useState([]);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [fileId, setFileId] = useState("");
  const [checkedFiles, setCheckedFiles] = useState([]);
  const [metaArr, setMetaArr] = useState([]);
  const [tempArray, setTempArray] = useState([]);
  const [noFiles, setNoFiles] = useState(false);
  const [metaData, setMetaData] = useState({
    name: "",
    pressure: 0,
    volumeOfWater: 0,
    volumeOfEngine: 0,
    nozzleSize: 0,
    rocketDryMass: 0,
    parachuteSize: 0,
    noParachut: false,
  });
  let [deviceData, setDeviceData] = useState([
    {
      name: "",
      pressure: 0,
      volumeOfWater: 0,
      volumeOfEngine: 0,
      nozzleSize: 0,
      rocketDryMass: 0,
      parachuteSize: 0,
      noParachut: false,
      decentSpeed: 0,
      topSpeed: 0,
      totalFlightTime: 0,
      apogeeAltitude: 0,
      apogeeTime: 0,
      coastTime: 0,
    },
  ]);

  const logoutHandler = async () => {
    setTimeout(() => {
      setAdminCookie({
        fName: null,
        lName: null,
        token: null,
        userId: null,
      });
      let hostname = window.location.host;
      window.location.assign(
        `${window.location.protocol}//${hostname}/super-admin`
      );
    });
  };
  const handleChangePage = (event, newPage) => {
    setPaged(event?.selected);
    let urlOrderBy = params.get("orderBy") || "createdAt";
    let urlorder = params.get("order") || "desc";
    getLaunchData(myUser, event?.selected, pageLimit, urlOrderBy, urlorder);
    history.replace({
      pathname: "/launchtrakfiles",
      search:
        `?${serial ? `serial=${serial}&` : ""}` +
        "page=" +
        event.selected +
        "&limit=" +
        pageLimit +
        "&orderBy=" +
        urlOrderBy +
        "&order=" +
        urlorder,
    });
  };
  const onSetOrder = (event, property) => {
    let orderTemp = order === "asc" ? "desc" : "asc";
    let urlPage = parseInt(params.get("page")) || 0;
    let urlLimit = parseInt(params.get("limit")) || pageLimit;
    let urlSerial = params.get("serial");
    history.replace({
      pathname: "/launchtrakfiles",
      search:
        `?${urlSerial ? `serial=${urlSerial}&` : ""}` +
        "page=" +
        urlPage +
        "&limit=" +
        urlLimit +
        "&orderBy=" +
        property +
        "&order=" +
        orderTemp,
    });
    getLaunchData(myUser, urlPage, urlLimit, property, orderTemp, true);
    setPaged(urlPage);
    setSerial(urlSerial);
    setPageLimit(urlLimit);
    setOrder(orderTemp);
    setOrderBy(property);
  };
  const handleSelectAllClick = (event) => {
    if (event?.target?.checked) {
      return;
    }
    setSelected([]);
  };

  const SnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    feedBackMsg(false, "", "");
  };

  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };
  // RESET ALL STATES
  function reset() {
    setCheckedFiles([]);
    setMetaArr([]);
    setOpen(false);
    setFileNames([]);
    setScanLoading(false);
    setTempArray([]);
    setNoFiles(false);
    setDeviceData([
      {
        name: "",
        pressure: 0,
        volumeOfWater: 0,
        volumeOfEngine: 0,
        nozzleSize: 0,
        rocketDryMass: 0,
        parachuteSize: 0,
        noParachut: false,
        decentSpeed: 0,
        topSpeed: 0,
        totalFlightTime: 0,
        apogeeAltitude: 0,
        apogeeTime: 0,
        coastTime: 0,
      },
    ]);
  }
  // Connect to a new device
  async function connectSerial() {
    try {
      console.log("Came in connectSerial");
      port = await navigator?.serial?.requestPort();
      await port?.open({ baudRate: 115200 });
      let settings = {};
      settings.dataTerminalReady = true;
      settings.requestToSend = true;
      if (Object.keys(settings)?.length > 0) await port?.setSignals(settings);
      // eslint-disable-next-line no-undef
      textEncoder = new TextEncoderStream();
      writableStreamClosed = textEncoder?.readable?.pipeTo(port?.writable);
      writer = textEncoder?.writable?.getWriter();
      setOpen(true);
      console.log("Call listenToPort");
      await listenToPort();
    } catch (e) {
      feedBackMsg(true, "warning", "Serial Connection Failed " + e);
      reset();
    }
  }

  async function listenToPort() {
    console.log("Inside listenToPort");
    // eslint-disable-next-line no-undef
    const textDecoder = new TextDecoderStream();
    readableStreamClosed = port?.readable?.pipeTo(textDecoder?.writable);
    reader = textDecoder?.readable?.getReader();
    let buffer = "";
    try {
      let allfiles = [];
      while (true) {
        const { value, done } = await reader.read();
        console.log("value......", value);
        console.log("currentCommand...", currentCommand);
        if (done) {
          // reader.releaseLock();
          break;
        }
        // PROCESS FOR LIST FILES FROM DEVICE
        if (currentCommand == "L") {
          await delay(1000);
          const fileArray = value.split(" ");
          // console.log(fileArray,"spiltttt");

          fileArray?.forEach(function (item) {
            if (item.startsWith("ltk")) {
              let temp = item?.split(".")[0];
              if (!allfiles?.includes(temp)) {
                allfiles.push(temp);
              }
              // filenames.push(value);
            }
          });

          setFileNames([...allfiles]);
        }
        // PROCESS FOR CONVERT TO BINARY
        if (currentCommand == "B") {
          // Every dump starts and ends with a "@\n" line, ignore it
          if (value.startsWith("@")) {
            if (startedDumpingFile) {
              // subject.next();
              currentCommand = "P";
              await sendCommand("P");
            }
            // await delay(2000);

            startedDumpingFile = !startedDumpingFile;
          } else if (startedDumpingFile) {
            dumpedData += value;
          }
        }
        // PROCESS FOR GET VALUE OF INTEREST FROM DEVICE
        if (currentCommand === "P") {
          valuesOfInterest.push(value);
          buffer = buffer + value;
          if (buffer.includes("Impact Accel:")) {
            buffer = "";
            subject.next();
          }
          console.log(value, "pppppp");
        }
        // // PROCESS FOR CLOSE FILE
        // if (currentCommand == "C") {
        //   subject.next();
        // }
        // PROCESS FOR DELETE FILES FROM DEVICE
        if (currentCommand == "E") {
          if (value.includes("[Y/n]")) {
            await sendCommand("Y");
          }
          if (value.includes("Done")) {
            subject.next();
          }
        }
      }
    } catch (e) {
      feedBackMsg(true, "warning", "Serial Connection Failed " + e);
      reset();
    } finally {
      reader.releaseLock();
    }
  }

  async function sendCommand(command) {
    try {
      console.log("inside sendCommand", command);
      // currentCommand = command
      command += "\r";
      await writer?.write(command);
      console.log("command..", command);
      if (command?.trim()?.startsWith("\x03")) {
        console.log("inside if for echo");
        // eslint-disable-next-line no-undef
        echo(false);
      }
    } catch (error) {
      console.log("error....", error);
      feedBackMsg(true, "warning", "Serial Connection Failed " + error);
      reset();
    }
  }
  // // Asks the LaunchTrak device for the list of files using the "L" command
  async function getFilenames() {
    // setLoadings(true);
    currentCommand = "L";
    await sendCommand("L");
  }
  // Ask launchtrak to erase file with the "E" command
  async function deleteFilesFromDevice() {
    return new Promise(async (resolve, reject) => {
      currentCommand = "E";
      await sendCommand("E");
      const a = subject.subscribe((data) => {
        a.unsubscribe();
        resolve("done");
      });
    });
  }
  // Ask launchtrak to open file with the "B" command
  async function viewFileData() {
    return new Promise(async (resolve, reject) => {
      currentCommand = "B";
      await sendCommand("B");
      await delay(3000);
      openFile();
      await delay(3000);
      dumpFile();

      // await delay(6000);
      // currentCommand = "P";
      // await sendCommand("P");
      // await delay(1000);
      // console.log("cvvvvv command")
      // currentCommand = "C";
      // await sendCommand("C");

      const a = subject.subscribe((data) => {
        let dataArray = dumpedData.split("\n");
        const _data = createDataArray(dataArray);
        dumpedData = "";
        currentCommand = "";
        a.unsubscribe();
        resolve(_data);
      });
    });
  }

  // After asking launchtrak to open file, send it a command "[filename]" where [filename] is the file you want to open
  async function openFile() {
    // The command ignores the ltk part of the filename so just give numbers (characters 3 to 5)
    await sendCommand(localStorage.filename.substring(3, 6));
  }

  // Once a file is opened, dump the data with "H" command
  async function dumpFile() {
    await sendCommand("H");
  }
  // Simple delay
  function delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  async function disconnectFromSerial() {
    try {
      // Cancel the reader
      if (reader) {
        await reader.cancel();
        await reader.releaseLock();
      }
      // Close the readable stream
      if (readableStreamClosed) {
        await readableStreamClosed.catch(() => {});
      }
      // Close the writer
      if (writer) {
        await writer.close();
        await writableStreamClosed;
      }
      // Close the port
      if (port) {
        await port.close();
      }
    } catch (error) {
      feedBackMsg(true, "warning", "Serial Connection Failed " + error);
      reset();
    }
  }

  function handleClickEdit(data) {
    setEditOpen(true);
    setFileId(data?._id);
    setMetaData({
      name: data?.name,
      pressure: data?.pressure,
      volumeOfWater: data?.volumeOfWater,
      volumeOfEngine: data?.volumeOfEngine,
      nozzleSize: data?.nozzleSize,
      rocketDryMass: data?.rocketDryMass,
      parachuteSize: data?.parachuteSize,
      noParachut: data?.noParachut,
    });
  }

  function handleClickDel(id) {
    setFileId(id);
    setDeleteOpen(true);
  }
  // Use the data from the local file to populate the graphs
  // function useLocalData() {
  //   let dataArray = localData.split("\n");
  //   createDataArray(dataArray);
  // }
  // This method is created for cross-browser compatibility, if you don't
  // need to support IE11, you can use Array.prototype.sort() directly

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - deviceInfo.length) : 0;
  // // Using the raw data from the LaunchTrak, split it up according to all the values (time, roll, pitch, etc)
//filtering the spike for graph of pressure and altitude

const filterPressureSpike = async (data) => {
  let graphData = [...data];
  if (!graphData || graphData === 0) return [];

  //If the first pressure value is greater than 1,000,000 then replace with second pressure value.
  if (
    graphData.length > 1 &&
    graphData[0].press !== undefined &&
    graphData[0].press >= 1000000 &&
    graphData[1] &&
    graphData[1].press !== undefined
  ) {
    graphData[0].press = graphData[1].press;
  }

  // If current pressure is greater than 10 X previous pressure then replace current with previous.
  for (let i = 1; i < graphData.length; i++) {
    if (
      graphData[i].press !== undefined &&
      graphData[i - 1].press !== undefined &&
      graphData[i].press >= graphData[i - 1].press * 10
    ) {
      graphData[i].press = graphData[i - 1].press;
    }
  }
  return graphData;
};

async function createDataArray(dataArray) {
  let graphData = [];
  let initialAltitude = 0;
  let validLinesSoFar = 0;
  let startThrustTime = 0;
  let endThrustTime = 0;
  let startedThrust = false;
  let endedThrust = false;
  let thrustTime = 0;
  let previousTime = 0.0;
  let previousAcceleration = 0.0;
  let prevAX = 0.0;
  let prevAY = 0.0;
  let prevAZ = 0.0;
  let velocity = 0.0;
  let prevVX = 0.0; //added code
  let prevVY = 0.0; //added code
  let prevVZ = 0.0; //added code
  let coastTime = 0.0;
  let maxAltitude = 0;
  let maxAltitudeTime = 0;
  let maxThrust = 0;
  let avgThrust = 0;
  let avgThrustCount = 0;
  let maxHighGAcceleration = 0;
  let endOfFlightTime = 0;
  
  // First, create an array of raw data points
  let rawDataPoints = [];
  
  for (let i = 0; i < dataArray?.length - 5; i++) {
    let lineArray = dataArray[i]?.split(",");
    if (lineArray?.length > 11) {
      if (lineArray[0]?.match(/^\d/)) {
        rawDataPoints.push({
          time: lineArray[0] / 1000000,
          roll: Number(lineArray[1]),
          pitch: Number(lineArray[2]),
          yaw: Number(lineArray[3]),
          ax: Number(lineArray[4]),
          ay: Number(lineArray[5]),
          az: Number(lineArray[6]),
          press: Number(lineArray[7]),
          temp: Number(lineArray[8]),
          hgx: Number(lineArray[9]),
          hgy: Number(lineArray[10]),
          hgz: Number(lineArray[11])
        });
      }
    }
  }

  // Filter pressure spikes BEFORE calculating altitude
  const filteredDataPoints = await filterPressureSpike(rawDataPoints);
  
  // Now process filtered data and calculate altitude and other metrics
  for (let i = 0; i < filteredDataPoints.length; i++) {
    const point = filteredDataPoints[i];
    
    // Convert time to seconds
    let current_time = point.time;
    
    // HERE CALCULATION OF ACCELERATION
    // Acceleration = sqrt(ax^2 + ay^2 + az^2)
    let x = point.ax;
    let y = point.ay;
    let z = point.az;
    let accel = Math.sqrt(x * x + y * y + z * z);
    
    // HERE CALCULATION OF VELOCITY
    // Velocity
    let deltaTime = current_time - previousTime;
    let deltaVX = deltaTime * ((prevAX + x) / 2.0);
    let deltaVY = deltaTime * ((prevAY + y) / 2.0);
    let deltaVZ = deltaTime * ((prevAZ + z) / 2.0);
    let vx = prevVX + deltaVX;
    let vy = prevVY + deltaVY;
    let vz = prevVZ + deltaVZ;
    velocity = Math.sqrt(vx * vx + (vy * vy) + vz * vz); // Fixed parenthesis issue
    
    // Altitude - using the filtered pressure data
    let seaLevelPressure = 101325.0;
    let pressure = point.press;
    let temperature = point.temp;
    let altitude =
      ((Math.pow(seaLevelPressure / pressure, 1.0 / 5.257) - 1.0) *
        (temperature + 273.15)) /
      0.0065;
    if (validLinesSoFar == 0) {
      initialAltitude = altitude;
    }
    altitude -= initialAltitude;

    // Thrust Time
    if (accel > 15.0 && !startedThrust) {
      startThrustTime = current_time;
      startedThrust = true;
    }
    if (startedThrust && !endedThrust) {
      if (Math.abs(accel) > maxThrust) {
        maxThrust = Math.abs(accel);
      }
      avgThrust = avgThrust + Math.abs(accel);
      avgThrustCount = avgThrustCount + 1;
      if (accel < 9.8) {
        endThrustTime = current_time;
        endedThrust = true;
        thrustTime = endThrustTime - startThrustTime;
        avgThrust = avgThrust / avgThrustCount;
      }
    }
    if (thrustTime > 0) {
      if (altitude > maxAltitude) {
        maxAltitude = altitude;
        maxAltitudeTime = current_time;
      }
    }

    // Max High G Accel Magnitude
    let hgx = point.hgx;
    let hgy = point.hgy;
    let hgz = point.hgz;
    let highGAcceleration = Math.sqrt(hgx * hgx + hgy * hgy + hgz * hgz);
    if (highGAcceleration > maxHighGAcceleration) {
      maxHighGAcceleration = highGAcceleration;
      endOfFlightTime = current_time;
    }
    
    graphData.push({
      time: point.time,
      roll: point.roll,
      pitch: point.pitch,
      yaw: point.yaw,
      ax: point.ax,
      ay: point.ay,
      az: point.az,
      press: point.press,
      temp: point.temp,
      hgx: point.hgx,
      hgy: point.hgy,
      hgz: point.hgz,
      acc: accel,
      vel: velocity,
      altitude: altitude,
      highGAcceleration: highGAcceleration,
    });

    validLinesSoFar = validLinesSoFar + 1;
    previousAcceleration = accel;
    prevAX = x;
    prevAY = y;
    prevAZ = z;
    prevVX = vx;
    prevVY = vy;
    prevVZ = vz;
    previousTime = current_time;
  }
  
  // Update Values of Interest
  // HERE CALCULATION OF VALUE OF INTEREST
  const combinedString = valuesOfInterest
    .join("") // Join array into a single string
    .replace(/\r\n|\t/g, "") // Remove carriage returns and tabs
    .replace(/Processing data in \w+\.bin/g, "");
  
  // Split the string into key-value pairs
  const keyValuePairs = combinedString
    .split(/(?<=\))(?=[A-Za-z])/)
    .map((pair) => pair.split(":"));
  
  // Create an object from the key-value pairs
  const resultObject = keyValuePairs.reduce((acc, [key, value]) => {
    if (key && value) {
      acc[key.trim()] = value.trim();
    }
    return acc;
  }, {});
  
  valuesOfInterest = [];
  const parseValue = (value) => parseFloat(value?.split(" ")[0]);
  coastTime =
    parseValue(resultObject["Apogee Time"]) -
    parseValue(resultObject["Thrust Time"]);
  resultObject.coastTime = `${coastTime} (s)`;
  dumpedData = "";
  currentCommand = "";
  
  console.log(graphData,"graphData");
  
  return {
    valuesOfInterest: resultObject,
    graphData: graphData, // Already filtered data
  };
  // Finished with data, generate graphs
}
  const getLaunchData = async (
    user = myUser,
    page,
    pageLimit,
    orderBy,
    order,
    orderFlag
  ) => {
    if (orderFlag !== true) {
      setLoading(true);
    }
    let res = await getLaunchTrekData(
      user?.token,
      page,
      pageLimit,
      orderBy,
      order,
      params.get("serial") ? params.get("serial") : null
    );
    if (res?.error) {
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    } else {
      setDeviceInfo(res?.res?.data?.result);
      let divisor = parseInt(res?.res?.data?.totalPages / pageLimit);
      let remainder = parseInt(
        res?.res?.data?.totalPages % pageLimit == 0 ? 0 : 1
      );
      setNoOfPages(divisor + remainder);
      setCurrPage(page);
      let tempDevice = [];
      // res?.res?.data?.result?.map((data) => {
      //   tempDevice.push(data?.district);
      // });
      // setAllDevice(tempDevice);
      setLoading(false);
    }
  };
  useEffect(() => {
    const _cookie = getCookie("recoil-persist");
    if (!_cookie) {
      logoutHandler();
    } else {
      const user = JSON.parse(_cookie)["KT_app"];
      setmyUser(user);
      let urlPage = parseInt(params.get("page")) || 0;
      let urlLimit = parseInt(params.get("limit")) || pageLimit;
      let urlSerial = params.get("serial");
      let urlOrderBy = params.get("orderBy") || "createdAt";
      let urlorder = params.get("order") || "desc";
      if (parseInt(params.get("page")) || parseInt(params.get("limit"))) {
        history.replace({
          pathname: "/launchtrakfiles",
          search:
            `?${urlSerial ? `serial=${urlSerial}&` : ""}` +
            "page=" +
            urlPage +
            "&limit=" +
            urlLimit +
            "&orderBy=" +
            urlOrderBy +
            "&order=" +
            urlorder,
        });
        getLaunchData(user, urlPage, urlLimit, urlOrderBy, urlorder);
        setPaged(urlPage);
        setSerial(urlSerial);
        setPageLimit(urlLimit);
      } else {
        history.push({
          pathname: "/launchtrakfiles",
          search:
            `?${urlSerial ? `serial=${urlSerial}&` : ""}` +
            `page=0&limit=${pageLimit}&orderBy=${orderBy}&order=${order}`,
        });
        getLaunchData(user, 0, pageLimit, orderBy, order);
      }
    }
  }, []);

  return (
    <div style={{ height: "100%", overflow: "hidden" }}>
      <NavBar />
      <br />
      <div className="d-flex justify-content-end">
        <button className="scan-button" onClick={() => connectSerial()}>
          <img src={scan} alt="scan" width={25} />
          <span className="scan-btn-span">Select device</span>
        </button>
      </div>
      <br />

      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          className="loading-overlay"
        >
          <CircularProgress />
        </Box>
      ) : (
        <div className="max-h-screen">
          {deviceInfo?.length ? (
            <Box sx={{ width: "100%" }}>
              <div className="d-flex justify-content-end align-items-end">
                <ReactPaginate
                  previousLabel="Previous"
                  nextLabel="Next"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={noOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handleChangePage}
                  containerClassName="pagination"
                  activeClassName="activePage active"
                  forcePage={currPage}
                />
              </div>
              {console.log(fileNames, "filenames")}
              <Box sx={{ width: "100%", overflow: "none" }}>
                <Paper sx={{ width: "100%", mb: 2 }}>
                  <EnhancedTableToolbar numSelected={selected.length} />
                  <TableContainer
                    sx={{
                      maxHeight: "calc(100vh - 250px)",
                      overflow: "auto",
                      width: "100%",
                    }}
                  >
                    <Table
                      sx={{
                        tableLayout: "fixed",
                        minWidth: { xs: 300, sm: 500, md: 750 },
                      }}
                      aria-labelledby="tableTitle"
                      size={"small"}
                      stickyHeader
                    >
                      <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={onSetOrder}
                        rowCount={deviceInfo?.length}
                      />
                      <TableBody>
                        {deviceInfo?.map((data, index) => {
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={data._id}
                            >
                              <TableCell
                                align="center"
                                className="text-truncate"
                                style={{ maxWidth: "150px" }}
                              >
                                {data?.name}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="text-truncate"
                                style={{ maxWidth: "150px" }}
                              >
                                {data?.originalName}
                              </TableCell>
                              <TableCell align="center">
                                {data?.pressure
                                  ? data?.pressure?.toFixed(2) + " " + "PSI"
                                  : "--"}
                              </TableCell>
                              <TableCell align="right">
                                {data?.volumeOfWater
                                  ? data?.volumeOfWater?.toFixed(2) + " " + "ml"
                                  : "--"}
                              </TableCell>
                              <TableCell align="right">
                                {data?.volumeOfEngine
                                  ? data?.volumeOfEngine?.toFixed(2) +
                                    " " +
                                    "ml"
                                  : "--"}
                              </TableCell>
                              <TableCell align="right">
                                {data?.nozzleSize
                                  ? data?.nozzleSize?.toFixed(2) + " " + "mm"
                                  : "--"}
                              </TableCell>
                              <TableCell align="right">
                                {data?.rocketDryMass
                                  ? data?.rocketDryMass?.toFixed(2) + " " + "g"
                                  : "--"}
                              </TableCell>
                              <TableCell align="right">
                                {data?.noParachut
                                  ? "No Parachut"
                                  : data?.parachuteSize
                                  ? data?.parachuteSize?.toFixed(2) + " " + "m²"
                                  : "--"}
                              </TableCell>
                              <TableCell align="right">
                                {data?.createdAt?.split("T")[0]}
                              </TableCell>
                              <TableCell>
                                <Link
                                  to={{
                                    pathname: `/launchtrakfiles/${data?._id}}`,
                                    state: {
                                      id: data?._id,
                                      fileName:
                                        data?.name || data?.originalName,
                                    },
                                  }}
                                  className="btn btn-sm btn-outline-primary"
                                >
                                  View
                                </Link>
                              </TableCell>
                              <TableCell align="right">
                                {/* <EditOutlinedIcon
                                  sx={{ color: "#348BE3", cursor: "pointer" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleClickEdit(data);
                                  }}
                                /> */}

                                <Tooltip title="Edit" placement="left">
                                  <button
                                    className="btn btn-sm btn-outline-primary mr-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClickEdit(data);
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 30 30"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M13.75 5H5C4.33696 5 3.70107 5.26339 3.23223 5.73223C2.76339 6.20107 2.5 6.83696 2.5 7.5V25C2.5 25.663 2.76339 26.2989 3.23223 26.7678C3.70107 27.2366 4.33696 27.5 5 27.5H22.5C23.163 27.5 23.7989 27.2366 24.2678 26.7678C24.7366 26.2989 25 25.663 25 25V16.25"
                                        stroke="#495057"
                                        stroke-width="2.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M23.125 3.125C23.6223 2.62772 24.2967 2.34835 25 2.34835C25.7033 2.34835 26.3777 2.62772 26.875 3.125C27.3723 3.62228 27.6517 4.29674 27.6517 5C27.6517 5.70326 27.3723 6.37772 26.875 6.875L15 18.75L10 20L11.25 15L23.125 3.125Z"
                                        stroke="#495057"
                                        stroke-width="2.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </button>
                                </Tooltip>
                                <DeleteOutlineIcon
                                  sx={{ color: "#348BE3", cursor: "pointer" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleClickDel(data?._id);
                                  }}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                        {emptyRows > 0 && (
                          <TableRow
                            style={{ height: (dense ? 33 : 53) * emptyRows }}
                          >
                            <TableCell colSpan={6} />
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
                <Snackbar
                  open={snackBarShow}
                  autoHideDuration={3000}
                  onClose={SnackClose}
                >
                  <Alert
                    onClose={SnackClose}
                    severity={snackBarSeverity}
                    sx={{ width: "100%" }}
                  >
                    {snackBarMessage}
                  </Alert>
                </Snackbar>
              </Box>
            </Box>
          ) : (
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={notFound} alt="notFound" width={600} />
              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: 48,
                  color: "#348BE3",
                }}
              >
                No files found!
              </p>
              <span
                style={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: 23,
                  color: "#82B6FF",
                }}
              >
                There are currently no files available. Please check back later
              </span>
            </Box>
          )}
        </div>
      )}
      <EditFile
        open={editOpen}
        setOpen={setEditOpen}
        fileId={fileId}
        edit={true}
        getLaunchData={getLaunchData}
        metaData={metaData}
        setMetaData={setMetaData}
        page={page}
        pageLimit={pageLimit}
        setSnackBarShow={setSnackBarShow}
        setSnackBarMessage={setSnackBarMessage}
        setSnackBarSeverity={setSnackBarSeverity}
      />
      <DeleteFiles
        open={deleteOpen}
        setOpen={setDeleteOpen}
        fileId={fileId}
        getLaunchData={getLaunchData}
        page={parseInt(params.get("page")) || 0}
        pageLimit={parseInt(params.get("limit")) || pageLimit}
        orderBy={params.get("orderBy") || "createdAt"}
        order={params.get("order") || "desc"}
        setSnackBarShow={setSnackBarShow}
        setSnackBarMessage={setSnackBarMessage}
        setSnackBarSeverity={setSnackBarSeverity}
        moduleDel="deleteFromDatabase"
      />
      <ScanDevice
        open={open}
        setOpen={setOpen}
        fileNames={fileNames}
        setFileNames={setFileNames}
        getFilenames={getFilenames}
        viewFileData={viewFileData}
        listenToPort={listenToPort}
        deviceData={deviceData}
        scanLoading={scanLoading}
        setScanLoading={setScanLoading}
        delay={delay}
        setDeviceData={setDeviceData}
        setSnackBarShow={setSnackBarShow}
        setSnackBarMessage={setSnackBarMessage}
        setSnackBarSeverity={setSnackBarSeverity}
        getLaunchData={getLaunchData}
        setMetaData={setMetaData}
        metaData={metaData}
        page={page}
        pageLimit={pageLimit}
        disconnectFromSerial={disconnectFromSerial}
        deleteFilesFromDevice={deleteFilesFromDevice}
        checkedFiles={checkedFiles}
        setCheckedFiles={setCheckedFiles}
        metaArr={metaArr}
        setMetaArr={setMetaArr}
        tempArray={tempArray}
        setTempArray={setTempArray}
        noFiles={noFiles}
        setNoFiles={setNoFiles}
      />
    </div>
  );
}
